<template>
  <vx-card class="w-full">
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" visible-com-name :visible-field-form="false" />

    <FileUploader type="images" title="이미지 업로드" :readonly="board.readonly" v-model="form.fileList" />
    <!-- 파일첨부 -->
    <FileDownload :isChange="!board.readonly" class="mt-7" />
  </vx-card>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FileDownload from "@/components/FileDownload.vue";
import FileUploader from "@/components/FileUploader.vue";
export default {
  components: {FileUploader, FileDownload, FieldSelectModule, FileUploadModule },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    docProjectId: String | Number,
  },
  computed: {},
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(/*value*/) {},
    },
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.form && value) {
          const keys = Object.keys(this.form);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        fileList: [],
      },
    };
  },
};
</script>

<style scoped lang="scss"></style>
